(() => {
  const name = 'ug-jp-campaign-countdown';
  if (customElements.get(name)) return;

  customElements.define(name, class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.units = ['days', 'hours', 'minutes', 'seconds'].map((unit) => this.querySelector(`[data-countdown-unit="${unit}"]`));
      const value = this.dataset.deadline?.trim() || '';
      this.deadline = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(value) ? Date.parse(value) : NaN;
      const refresh = () => this.update();
      document.addEventListener('visibilitychange', refresh, { signal: this.controller.signal });
      window.addEventListener('pageshow', refresh, { signal: this.controller.signal });
      this.update();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
    }

    update() {
      clearTimeout(this.timer);
      if (!this.controller || !this.isConnected) return;
      const remaining = Number.isFinite(this.deadline) ? Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000)) : 0;
      const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
      this.units.forEach((element, index) => {
        if (!element) return;
        const value = String(values[index]).padStart(2, '0');
        if (element.textContent !== value) element.textContent = value;
      });
      this.toggleAttribute('data-expired', remaining === 0);
      if (remaining > 0 && !document.hidden) this.timer = setTimeout(() => this.update(), 1000);
    }
  });
})();
